// Leadership Users with roles
export const leadershipUsers = {
    president: ['president@nlngra.com', 'chief@nlngra.com', 'chairman@nlngra.com'],
    vicePresident: ['vp@nlngra.com', 'vicepresident@nlngra.com', 'deputy@nlngra.com'],
    secretary: ['secretary@nlngra.com', 'generalsecretary@nlngra.com'],
    treasurer: ['treasurer@nlngra.com', 'finance@nlngra.com'],
    admin: ['admin@nlngra.com', 'richard@nlngra.com', 'paul@nlngra.com', 'manager@nlngra.com']
};

// All roles with permissions
export const roles = [
    { id: 'president', name: 'President', level: 5, canDelegate: true, canApprove: true, canReject: true, canManageUsers: true, canChangeLocation: true, canManagePricing: true, canManageBlackout: true },
    { id: 'vicePresident', name: 'Vice President', level: 4, canDelegate: false, canApprove: true, canReject: true, canManageUsers: false, canChangeLocation: true, canManagePricing: false, canManageBlackout: true },
    { id: 'secretary', name: 'Secretary', level: 3, canDelegate: false, canApprove: true, canReject: true, canManageUsers: false, canChangeLocation: false, canManagePricing: false, canManageBlackout: false },
    { id: 'treasurer', name: 'Treasurer', level: 3, canDelegate: false, canApprove: true, canReject: true, canManageUsers: false, canChangeLocation: false, canManagePricing: true, canManageBlackout: false },
    { id: 'admin', name: 'Admin', level: 4, canDelegate: false, canApprove: true, canReject: true, canManageUsers: true, canChangeLocation: true, canManagePricing: true, canManageBlackout: true }
];

// Mock users for delegation
export const availableUsers = [
    { id: 1, name: 'John Doe', email: 'john@nlngra.com', role: 'Secretary', roleId: 'secretary', phone: '+2348012345678', whatsApp: '+2348012345678' },
    { id: 2, name: 'Jane Smith', email: 'jane@nlngra.com', role: 'Treasurer', roleId: 'treasurer', phone: '+2348012345679', whatsApp: '+2348012345679' },
    { id: 3, name: 'Mike Johnson', email: 'mike@nlngra.com', role: 'Admin', roleId: 'admin', phone: '+2348012345680', whatsApp: '+2348012345680' },
    { id: 4, name: 'Sarah Williams', email: 'sarah@nlngra.com', role: 'Vice President', roleId: 'vicePresident', phone: '+2348012345681', whatsApp: '+2348012345681' },
    { id: 5, name: 'David Brown', email: 'david@nlngra.com', role: 'Secretary', roleId: 'secretary', phone: '+2348012345682', whatsApp: '+2348012345682' }
];

// Jersey Sizes
export const jerseySizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'];

// ===== ALL FACILITIES (19 total) =====
export const facilities = [
    // Event Spaces (5)
    {
        id: 1,
        name: 'Abuja Boulevard',
        category: 'Event Space',
        image: 'https://images.pexels.com/photos/260922/pexels-photo-260922.jpeg?auto=compress&cs=tinysrgb&w=800',
        description: 'Elegant boulevard perfect for outdoor events and gatherings with modern lighting and landscaping',
        capacity: '200 people',
        rating: 4.8,
        amenities: ['Outdoor Space', 'Stage Lighting', 'Parking', 'Sound System', 'Garden Views'],
        availability: '8 AM - 10 PM',
        price: '₦0 (Members)',
        location: 'Main Complex',
        size: '500 sqm',
        icon: 'fa-solid fa-building',
        requiresApproval: true,
        deposit: 0,
        residentialArea: true,
        images: ['image1.jpg', 'image2.jpg', 'image3.jpg'],
        alternateLocations: ['Banquet Hall', 'Market Square', 'Marquee Tent'],
        maintenanceStatus: 'operational',
        basePrice: 0,
        peakPrice: 0
    },
    {
        id: 2,
        name: 'Banquet Hall',
        category: 'Event Space',
        image: 'https://images.pexels.com/photos/169189/pexels-photo-169189.jpeg?auto=compress&cs=tinysrgb&w=800',
        description: 'Grand hall for weddings, parties, and corporate events with crystal chandeliers',
        capacity: '300 people',
        rating: 4.9,
        amenities: ['Stage', 'Dance Floor', 'AC', 'Catering Kitchen', 'Bridal Room'],
        availability: '8 AM - 11 PM',
        price: '₦0 (Members)',
        location: 'Main Building',
        size: '800 sqm',
        icon: 'fa-solid fa-hall',
        requiresApproval: true,
        deposit: 50000,
        residentialArea: false,
        images: ['hall1.jpg', 'hall2.jpg', 'hall3.jpg'],
        alternateLocations: ['Abuja Boulevard', 'Market Square', 'Sports Hall Complex'],
        maintenanceStatus: 'operational',
        basePrice: 0,
        peakPrice: 0
    },
    {
        id: 3,
        name: 'Market Square',
        category: 'Event Space',
        image: 'https://images.pexels.com/photos/264940/pexels-photo-264940.jpeg?auto=compress&cs=tinysrgb&w=800',
        description: 'Open square for markets, fairs, and community events with vendor stalls',
        capacity: '400 people',
        rating: 4.5,
        amenities: ['Open Space', 'Stalls', 'Lighting', 'Power Outlets', 'Water Access'],
        availability: '8 AM - 8 PM',
        price: '₦0 (Members)',
        location: 'Central Plaza',
        size: '1000 sqm',
        icon: 'fa-solid fa-store',
        requiresApproval: true,
        deposit: 40000,
        residentialArea: true,
        images: ['market1.jpg', 'market2.jpg'],
        alternateLocations: ['Abuja Boulevard', 'Banquet Hall', 'Marquee Tent'],
        maintenanceStatus: 'operational',
        basePrice: 0,
        peakPrice: 0
    },
    {
        id: 4,
        name: 'Marquee Tent',
        category: 'Event Space',
        image: 'https://images.pexels.com/photos/2403201/pexels-photo-2403201.jpeg?auto=compress&cs=tinysrgb&w=800',
        description: 'Spacious tent for outdoor events and parties with climate control',
        capacity: '150 people',
        rating: 4.6,
        amenities: ['Tent', 'Lighting', 'Flooring', 'Heaters', 'Fans'],
        availability: '8 AM - 10 PM',
        price: '₦0 (Members)',
        location: 'Garden Area',
        size: '300 sqm',
        icon: 'fa-solid fa-campground',
        requiresApproval: true,
        deposit: 20000,
        residentialArea: true,
        images: ['tent1.jpg', 'tent2.jpg'],
        alternateLocations: ['Abuja Boulevard', 'Market Square', 'Banquet Hall'],
        maintenanceStatus: 'operational',
        basePrice: 0,
        peakPrice: 0
    },
    {
        id: 5,
        name: 'West Bar Meeting Room',
        category: 'Meeting Room',
        image: 'https://images.pexels.com/photos/2774556/pexels-photo-2774556.jpeg?auto=compress&cs=tinysrgb&w=800',
        description: 'Professional meeting room ideal for leadership retreats, strategic sessions, and temporary storage needs.',
        capacity: '50-100 people',
        rating: 4.8,
        amenities: ['Projector', 'Whiteboard', 'Video Conferencing', 'High-Speed WiFi', 'Catering Service', 'Storage Space'],
        availability: '24/7',
        price: '₦0 (Members)',
        location: 'West Bar Wing',
        size: '200 sqm',
        icon: 'fa-solid fa-chalkboard-user',
        requiresApproval: true,
        deposit: 0,
        residentialArea: false,
        images: ['west1.jpg', 'west2.jpg'],
        alternateLocations: ['Clubhouse Alcove', 'Banquet Hall', 'Sports Hall Complex'],
        maintenanceStatus: 'operational',
        basePrice: 0,
        peakPrice: 0
    },

    // Bars/Lounges (4)
    {
        id: 6,
        name: 'Clubhouse West-Bar',
        category: 'Bar/Lounge',
        image: 'https://images.pexels.com/photos/941864/pexels-photo-941864.jpeg?auto=compress&cs=tinysrgb&w=800',
        description: 'Stylish bar area for cocktail parties and social events with premium ambiance',
        capacity: '80 people',
        rating: 4.6,
        amenities: ['Full Bar', 'Music System', 'TVs', 'Pool Tables', 'Dart Board'],
        availability: '4 PM - 2 AM',
        price: '₦0 (Members)',
        location: 'West Wing',
        size: '150 sqm',
        icon: 'fa-solid fa-martini-glass',
        requiresApproval: true,
        deposit: 25000,
        residentialArea: true,
        images: ['westbar1.jpg', 'westbar2.jpg'],
        alternateLocations: ['DBN Bar', 'Golf Course Bar', 'Hippo Bar'],
        maintenanceStatus: 'operational',
        basePrice: 0,
        peakPrice: 0
    },
    {
        id: 7,
        name: 'DBN Bar',
        category: 'Bar/Lounge',
        image: 'https://images.pexels.com/photos/274192/pexels-photo-274192.jpeg?auto=compress&cs=tinysrgb&w=800',
        description: 'Cozy bar with premium drinks and ambiance, perfect for casual gatherings',
        capacity: '50 people',
        rating: 4.5,
        amenities: ['Bar', 'Pool Table', 'TVs', 'Darts', 'Board Games'],
        availability: '4 PM - 2 AM',
        price: '₦0 (Members)',
        location: 'Ground Floor',
        size: '100 sqm',
        icon: 'fa-solid fa-martini-glass',
        requiresApproval: false,
        deposit: 0,
        residentialArea: false,
        images: ['dbn1.jpg', 'dbn2.jpg'],
        alternateLocations: ['Clubhouse West-Bar', 'Golf Course Bar', 'Hippo Bar'],
        maintenanceStatus: 'operational',
        basePrice: 0,
        peakPrice: 0
    },
    {
        id: 8,
        name: 'Golf Course Bar',
        category: 'Bar/Lounge',
        image: 'https://images.pexels.com/photos/1755385/pexels-photo-1755385.jpeg?auto=compress&cs=tinysrgb&w=800',
        description: 'Relaxing bar overlooking the golf course with panoramic views',
        capacity: '60 people',
        rating: 4.7,
        amenities: ['Bar', 'Outdoor Seating', 'TVs', 'Golf Simulator', 'Snacks'],
        availability: '10 AM - 8 PM',
        price: '₦0 (Members)',
        location: 'Golf Course',
        size: '120 sqm',
        icon: 'fa-solid fa-martini-glass',
        requiresApproval: false,
        deposit: 0,
        residentialArea: false,
        images: ['golfbar1.jpg', 'golfbar2.jpg'],
        alternateLocations: ['Clubhouse West-Bar', 'DBN Bar', 'Hippo Bar'],
        maintenanceStatus: 'operational',
        basePrice: 0,
        peakPrice: 0
    },
    {
        id: 9,
        name: 'Hippo Bar',
        category: 'Bar/Lounge',
        image: 'https://images.pexels.com/photos/1937092/pexels-photo-1937092.jpeg?auto=compress&cs=tinysrgb&w=800',
        description: 'Fun-themed bar for casual gatherings with games and entertainment',
        capacity: '40 people',
        rating: 4.4,
        amenities: ['Bar', 'Games', 'Music', 'Karaoke', 'Arcade'],
        availability: '4 PM - 12 AM',
        price: '₦0 (Members)',
        location: 'Poolside',
        size: '90 sqm',
        icon: 'fa-solid fa-martini-glass',
        requiresApproval: false,
        deposit: 0,
        residentialArea: true,
        images: ['hippo1.jpg', 'hippo2.jpg'],
        alternateLocations: ['Clubhouse West-Bar', 'DBN Bar', 'Golf Course Bar'],
        maintenanceStatus: 'operational',
        basePrice: 0,
        peakPrice: 0
    },

    // Meeting Spaces (2)
    {
        id: 10,
        name: 'Clubhouse Alcove',
        category: 'Meeting Room',
        image: 'https://images.pexels.com/photos/2774556/pexels-photo-2774556.jpeg?auto=compress&cs=tinysrgb&w=800',
        description: 'Intimate space for meetings and small gatherings with modern AV equipment',
        capacity: '30 people',
        rating: 4.7,
        amenities: ['WiFi', 'Whiteboard', 'Projector', 'Conference Phone', 'Coffee Machine'],
        availability: '8 AM - 8 PM',
        price: '₦0 (Members)',
        location: 'Clubhouse',
        size: '80 sqm',
        icon: 'fa-solid fa-building',
        requiresApproval: false,
        deposit: 0,
        residentialArea: false,
        images: ['alcove1.jpg', 'alcove2.jpg'],
        alternateLocations: ['West Bar Meeting Room', 'Banquet Hall', 'Sports Hall Complex'],
        maintenanceStatus: 'operational',
        basePrice: 0,
        peakPrice: 0
    },

    // Sports Facilities (5)
    {
        id: 11,
        name: 'Sports Hall Complex',
        category: 'Sports',
        image: 'https://images.pexels.com/photos/1752757/pexels-photo-1752757.jpeg?auto=compress&cs=tinysrgb&w=800',
        description: 'Multi-purpose sports hall for basketball, volleyball, and indoor sports with professional flooring',
        capacity: '250 people',
        rating: 4.8,
        amenities: ['Basketball Court', 'Volleyball Court', 'Seating', 'Locker Rooms', 'Showers', 'Scoreboard'],
        availability: '8 AM - 10 PM',
        price: '₦0 (Members)',
        location: 'Sports Complex',
        size: '1200 sqm',
        icon: 'fa-solid fa-basketball',
        requiresApproval: true,
        deposit: 35000,
        residentialArea: false,
        sportingOnly: true,
        images: ['sports1.jpg', 'sports2.jpg', 'sports3.jpg'],
        alternateLocations: ['Tennis Hut', 'Swimming Pool', 'Football Pitch'],
        maintenanceStatus: 'operational',
        basePrice: 0,
        peakPrice: 0
    },
    {
        id: 12,
        name: 'Tennis Courts',
        category: 'Sports',
        image: 'https://images.pexels.com/photos/573929/pexels-photo-573929.jpeg?auto=compress&cs=tinysrgb&w=800',
        description: 'Professional tennis courts for matches and practice',
        capacity: '8 players',
        rating: 4.7,
        amenities: ['Tennis Courts', 'Equipment', 'Lounge', 'Pro Shop', 'Ball Machine'],
        availability: '8 AM - 8 PM',
        price: '₦0 (Members)',
        location: 'Tennis Complex',
        size: '2 courts',
        icon: 'fa-solid fa-table-tennis-paddle-ball',
        requiresApproval: false,
        deposit: 0,
        residentialArea: false,
        sportingOnly: true,
        images: ['tennis1.jpg', 'tennis2.jpg'],
        alternateLocations: ['Sports Hall Complex', 'Squash Courts', 'Golf Course'],
        maintenanceStatus: 'operational',
        basePrice: 0,
        peakPrice: 0
    },
    {
        id: 13,
        name: 'Swimming Pool',
        category: 'Aquatics',
        image: 'https://images.pexels.com/photos/261326/pexels-photo-261326.jpeg?auto=compress&cs=tinysrgb&w=800',
        description: 'Olympic-size pool for swim events and parties with professional facilities',
        capacity: '100 people',
        rating: 4.9,
        amenities: ['Pool', 'Deck Chairs', 'Changing Rooms', 'Lifeguards', 'Heated Pool', 'Kids Pool'],
        availability: '8 AM - 8 PM',
        price: '₦0 (Members)',
        location: 'Recreation Center',
        size: '50m pool',
        icon: 'fa-solid fa-person-swimming',
        requiresApproval: true,
        deposit: 25000,
        residentialArea: false,
        sportingOnly: true,
        images: ['pool1.jpg', 'pool2.jpg', 'pool3.jpg'],
        alternateLocations: ['Sports Hall Complex', 'Wellness Center', 'Finima Nature Park'],
        maintenanceStatus: 'operational',
        basePrice: 0,
        peakPrice: 0
    },
    {
        id: 14,
        name: 'Football Pitch',
        category: 'Sports',
        image: 'https://images.pexels.com/photos/46798/the-ball-stadion-football-the-pitch-46798.jpeg?auto=compress&cs=tinysrgb&w=800',
        description: 'Regulation-size football pitch with grass surface',
        capacity: '22 players',
        rating: 4.9,
        amenities: ['Grass Pitch', 'Goals', 'Changing Rooms', 'Floodlights'],
        availability: '8 AM - 8 PM',
        price: '₦0 (Members)',
        location: 'Sports Ground',
        size: 'Full-size pitch',
        icon: 'fa-solid fa-futbol',
        requiresApproval: true,
        deposit: 30000,
        residentialArea: false,
        sportingOnly: true,
        images: ['football1.jpg', 'football2.jpg'],
        alternateLocations: ['Sports Hall Complex', 'Finima Nature Park', 'Golf Course'],
        maintenanceStatus: 'operational',
        basePrice: 0,
        peakPrice: 0
    },
    {
        id: 15,
        name: 'Squash Courts',
        category: 'Sports',
        image: 'https://images.pexels.com/photos/573929/pexels-photo-573929.jpeg?auto=compress&cs=tinysrgb&w=800',
        description: 'Professional squash courts for matches and practice',
        capacity: '4 players',
        rating: 4.7,
        amenities: ['Squash Courts', 'Equipment', 'Viewing Area'],
        availability: '8 AM - 8 PM',
        price: '₦0 (Members)',
        location: 'Sports Complex',
        size: '2 courts',
        icon: 'fa-solid fa-table-tennis-paddle-ball',
        requiresApproval: false,
        deposit: 0,
        residentialArea: false,
        sportingOnly: true,
        images: ['squash1.jpg', 'squash2.jpg'],
        alternateLocations: ['Sports Hall Complex', 'Tennis Courts', 'Wellness Center'],
        maintenanceStatus: 'operational',
        basePrice: 0,
        peakPrice: 0
    },

    // Golf Course (1)
    {
        id: 16,
        name: 'Golf Course',
        category: 'Sports',
        image: 'https://images.pexels.com/photos/1755385/pexels-photo-1755385.jpeg?auto=compress&cs=tinysrgb&w=800',
        description: '9-hole golf course for golfing activities only',
        capacity: '36 players',
        rating: 4.8,
        amenities: ['Golf Course', 'Practice Green', 'Club Rental'],
        availability: '7 AM - 6 PM',
        price: '₦0 (Members)',
        location: 'Golf Course',
        size: '9 holes',
        icon: 'fa-solid fa-golf-ball-tee',
        requiresApproval: true,
        deposit: 40000,
        residentialArea: false,
        sportingOnly: true,
        images: ['golf1.jpg', 'golf2.jpg'],
        alternateLocations: ['Sports Hall Complex', 'Finima Nature Park', 'Tennis Courts'],
        maintenanceStatus: 'operational',
        basePrice: 0,
        peakPrice: 0
    },

    // Kids Area (1)
    {
        id: 17,
        name: 'Kids Play Area',
        category: 'Kids',
        image: 'https://images.pexels.com/photos/933964/pexels-photo-933964.jpeg?auto=compress&cs=tinysrgb&w=800',
        description: 'Safe and fun play area for children with supervised activities',
        capacity: '30 kids',
        rating: 4.8,
        amenities: ['Play Equipment', 'Supervision', 'Toys', 'Safety Mats', 'Ball Pit', 'Slides'],
        availability: '9 AM - 7 PM',
        price: '₦0 (Members)',
        location: 'Family Zone',
        size: '150 sqm',
        icon: 'fa-solid fa-children',
        requiresApproval: false,
        deposit: 0,
        residentialArea: true,
        images: ['kids1.jpg', 'kids2.jpg'],
        alternateLocations: ['Finima Nature Park', 'Marquee Tent', 'Clubhouse Alcove'],
        maintenanceStatus: 'operational',
        basePrice: 0,
        peakPrice: 0
    },

    // Wellness Center (1)
    {
        id: 18,
        name: 'Wellness Center',
        category: 'Wellness',
        image: 'https://images.pexels.com/photos/260447/pexels-photo-260447.jpeg?auto=compress&cs=tinysrgb&w=800',
        description: 'Spa and wellness center for relaxation and therapeutic treatments',
        capacity: '15 people',
        rating: 4.9,
        amenities: ['Spa', 'Sauna', 'Massage Rooms', 'Steam Room', 'Jacuzzi', 'Meditation Room'],
        availability: '9 AM - 8 PM',
        price: '₦0 (Members)',
        location: 'Health Wing',
        size: '200 sqm',
        icon: 'fa-solid fa-spa',
        requiresApproval: true,
        deposit: 15000,
        residentialArea: false,
        images: ['wellness1.jpg', 'wellness2.jpg'],
        alternateLocations: ['Swimming Pool', 'Sports Hall Complex', 'Finima Nature Park'],
        maintenanceStatus: 'operational',
        basePrice: 0,
        peakPrice: 0
    },

    // Nature Park (1)
    {
        id: 19,
        name: 'Finima Nature Park',
        category: 'Outdoor',
        image: 'https://images.pexels.com/photos/2387873/pexels-photo-2387873.jpeg?auto=compress&cs=tinysrgb&w=800',
        description: 'Beautiful nature park for outdoor events and picnics with scenic views',
        capacity: '500 people',
        rating: 4.9,
        amenities: ['Nature Trails', 'Gazebos', 'BBQ Pits', 'Playground', 'Lake', 'Fishing'],
        availability: '8 AM - 6 PM',
        price: '₦0 (Members)',
        location: 'East End',
        size: '5000 sqm',
        icon: 'fa-solid fa-tree',
        requiresApproval: true,
        deposit: 30000,
        residentialArea: true,
        images: ['park1.jpg', 'park2.jpg', 'park3.jpg'],
        alternateLocations: ['Abuja Boulevard', 'Market Square', 'Marquee Tent'],
        maintenanceStatus: 'operational',
        basePrice: 0,
        peakPrice: 0
    }
];

// ===== ALL SECTIONS (18 total) =====
export const sections = [
    // Fitness (3)
    {
        id: 101,
        name: 'Athletics/Aerobics Club',
        category: 'Fitness',
        instructor: 'Coach Sarah Johnson',
        bio: 'Former Olympian with 15 years coaching experience, specialized in endurance training',
        schedule: 'Mon, Wed, Fri 6:00 AM - 7:00 AM',
        duration: '60 min',
        location: 'Sports Hall - Court A',
        capacity: 20,
        enrolled: 12,
        members: 12,
        level: 'All Levels',
        ageGroup: '16+',
        membershipFee: 0,
        image: 'https://images.pexels.com/photos/3768916/pexels-photo-3768916.jpeg?auto=compress&cs=tinysrgb&w=800',
        icon: 'fa-solid fa-person-running',
        equipment: {
            jersey: { required: true, sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'] },
            shoes: { required: true, sizes: ['36', '37', '38', '39', '40', '41', '42', '43', '44', '45'] },
            waterBottle: { required: false },
            towel: { required: false }
        },
        activities: [
            { id: 'a1', name: 'Morning Run', time: '6:00 AM', days: 'Mon/Wed/Fri', instructor: 'Coach Sarah' },
            { id: 'a2', name: 'HIIT Session', time: '5:00 PM', days: 'Tue/Thu', instructor: 'Coach Mike' },
            { id: 'a3', name: 'Weekend Marathon Training', time: '7:00 AM', days: 'Sat', instructor: 'Coach Sarah' }
        ],
        waitlist: []
    },
    {
        id: 102,
        name: 'Cycling Club',
        category: 'Fitness',
        instructor: 'Coach Thomas Peterson',
        bio: 'Professional cyclist, certified spinning instructor, completed Tour de France',
        schedule: 'Sat, Sun 6:00 AM - 7:30 AM',
        duration: '90 min',
        location: 'Cycling Track',
        capacity: 15,
        enrolled: 9,
        members: 9,
        level: 'Intermediate',
        ageGroup: '16+',
        membershipFee: 0,
        image: 'https://images.pexels.com/photos/3768916/pexels-photo-3768916.jpeg?auto=compress&cs=tinysrgb&w=800',
        icon: 'fa-solid fa-person-biking',
        equipment: {
            jersey: { required: true, sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'] },
            shorts: { required: true, sizes: ['XS', 'S', 'M', 'L', 'XL'] },
            helmet: { required: true, sizes: ['S', 'M', 'L'] },
            gloves: { required: true, sizes: ['S', 'M', 'L'] },
            waterBottle: { required: true }
        },
        activities: [
            { id: 'a35', name: 'Road Cycling', time: '6:00 AM', days: 'Sat/Sun', instructor: 'Coach Peterson' },
            { id: 'a36', name: 'Mountain Biking', time: '7:00 AM', days: 'Sat', instructor: 'Coach Peterson' },
            { id: 'a37', name: 'Indoor Spinning', time: '6:00 PM', days: 'Tue/Thu', instructor: 'Coach Peterson' }
        ],
        waitlist: []
    },
    {
        id: 103,
        name: 'Yoga & Meditation',
        category: 'Wellness',
        instructor: 'Guru Rajesh Sharma',
        bio: 'Yoga master, 30 years experience in meditation and spiritual healing',
        schedule: 'Mon, Wed, Fri 7:00 AM - 8:00 AM',
        duration: '60 min',
        location: 'Wellness Center - Studio',
        capacity: 20,
        enrolled: 15,
        members: 15,
        level: 'All Levels',
        ageGroup: '16+',
        membershipFee: 0,
        image: 'https://images.pexels.com/photos/260447/pexels-photo-260447.jpeg?auto=compress&cs=tinysrgb&w=800',
        icon: 'fa-solid fa-person-walking',
        equipment: {
            jersey: { required: true, sizes: ['XS', 'S', 'M', 'L', 'XL'] },
            yogaMat: { required: true },
            blocks: { required: false },
            strap: { required: false },
            blanket: { required: false }
        },
        activities: [
            { id: 'a33', name: 'Morning Yoga', time: '7:00 AM', days: 'Mon/Wed/Fri', instructor: 'Guru Sharma' },
            { id: 'a34', name: 'Meditation Session', time: '5:00 PM', days: 'Tue/Thu', instructor: 'Guru Sharma' },
            { id: 'a35', name: 'Weekend Retreat', time: '9:00 AM', days: 'Sat', instructor: 'Guru Sharma' }
        ],
        waitlist: []
    },

    // Sports (9)
    {
        id: 104,
        name: 'Badminton Club',
        category: 'Sports',
        instructor: 'Coach Michael Chen',
        bio: 'National champion, specialized in doubles training, former Olympic coach',
        schedule: 'Tue, Thu 4:00 PM - 5:30 PM',
        duration: '90 min',
        location: 'Sports Hall - Court B',
        capacity: 16,
        enrolled: 8,
        members: 8,
        level: 'Intermediate',
        ageGroup: '12+',
        membershipFee: 0,
        image: 'https://images.pexels.com/photos/61135/pexels-photo-61135.jpeg?auto=compress&cs=tinysrgb&w=800',
        icon: 'fa-solid fa-table-tennis-paddle-ball',
        equipment: {
            jersey: { required: true, sizes: ['XS', 'S', 'M', 'L', 'XL'] },
            racket: { required: false },
            shoes: { required: true, sizes: ['36', '37', '38', '39', '40', '41', '42', '43', '44', '45'] },
            shuttlecocks: { required: false }
        },
        activities: [
            { id: 'a3', name: 'Doubles Practice', time: '4:00 PM', days: 'Tue/Thu', instructor: 'Coach Michael' },
            { id: 'a4', name: 'Singles Tournament', time: '10:00 AM', days: 'Sat', instructor: 'Coach Wong' },
            { id: 'a5', name: 'Junior Training', time: '3:00 PM', days: 'Wed', instructor: 'Coach Michael' }
        ],
        waitlist: []
    },
    {
        id: 105,
        name: 'Basketball Club',
        category: 'Sports',
        instructor: 'Coach James Williams',
        bio: 'Former NBA player, specialized in youth development, 3x championship winner',
        schedule: 'Tue, Thu 5:00 PM - 6:30 PM',
        duration: '90 min',
        location: 'Basketball Court',
        capacity: 20,
        enrolled: 14,
        members: 14,
        level: 'All Levels',
        ageGroup: '10+',
        membershipFee: 0,
        image: 'https://images.pexels.com/photos/1752757/pexels-photo-1752757.jpeg?auto=compress&cs=tinysrgb&w=800',
        icon: 'fa-solid fa-basketball',
        equipment: {
            jersey: { required: true, sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'] },
            shorts: { required: true, sizes: ['XS', 'S', 'M', 'L', 'XL'] },
            basketballShoes: { required: true, sizes: ['36', '37', '38', '39', '40', '41', '42', '43', '44', '45'] },
            basketball: { required: false },
            kneePads: { required: false, sizes: ['S', 'M', 'L'] }
        },
        activities: [
            { id: 'a7', name: 'Team Practice', time: '5:00 PM', days: 'Tue/Thu', instructor: 'Coach James' },
            { id: 'a8', name: '3v3 Tournament', time: '2:00 PM', days: 'Sat', instructor: 'Coach Williams' },
            { id: 'a9', name: 'Youth Clinic', time: '10:00 AM', days: 'Sun', instructor: 'Coach James' }
        ],
        waitlist: []
    },
    {
        id: 106,
        name: 'Football Club',
        category: 'Sports',
        instructor: 'Coach Patrick Okonkwo',
        bio: 'Former professional player, UEFA licensed coach, ex-Nigerian national team',
        schedule: 'Sat 8:00 AM - 9:30 AM',
        duration: '90 min',
        location: 'Football Field',
        capacity: 22,
        enrolled: 18,
        members: 18,
        level: 'Competitive',
        ageGroup: '14+',
        membershipFee: 0,
        image: 'https://images.pexels.com/photos/46798/the-ball-stadion-football-the-pitch-46798.jpeg?auto=compress&cs=tinysrgb&w=800',
        icon: 'fa-solid fa-futbol',
        equipment: {
            jersey: { required: true, sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'] },
            shorts: { required: true, sizes: ['XS', 'S', 'M', 'L', 'XL'] },
            boots: { required: true, sizes: ['36', '37', '38', '39', '40', '41', '42', '43', '44', '45'] },
            shinGuards: { required: true, sizes: ['S', 'M', 'L'] },
            socks: { required: true, sizes: ['S', 'M', 'L'] }
        },
        activities: [
            { id: 'a11', name: 'Match Practice', time: '8:00 AM', days: 'Sat', instructor: 'Coach Patrick' },
            { id: 'a12', name: 'Friendly Matches', time: '4:00 PM', days: 'Sun', instructor: 'Coach Emeka' },
            { id: 'a13', name: 'Youth Academy', time: '4:00 PM', days: 'Wed/Fri', instructor: 'Coach Patrick' }
        ],
        waitlist: []
    },
    {
        id: 107,
        name: 'Golf Club',
        category: 'Sports',
        instructor: 'Pro Robert Wilson',
        bio: 'PGA certified professional, 25 years experience, former tour player',
        schedule: 'Sat, Sun 7:00 AM - 9:00 AM',
        duration: '120 min',
        location: 'Golf Course',
        capacity: 8,
        enrolled: 5,
        members: 5,
        level: 'All Levels',
        ageGroup: '18+',
        membershipFee: 0,
        image: 'https://images.pexels.com/photos/1755385/pexels-photo-1755385.jpeg?auto=compress&cs=tinysrgb&w=800',
        icon: 'fa-solid fa-golf-ball-tee',
        equipment: {
            jersey: { required: true, sizes: ['S', 'M', 'L', 'XL', 'XXL'] },
            gloves: { required: false, sizes: ['S', 'M', 'L'] },
            clubs: { required: false },
            balls: { required: false },
            tees: { required: false }
        },
        activities: [
            { id: 'a13', name: 'Swing Practice', time: '7:00 AM', days: 'Sat/Sun', instructor: 'Pro Wilson' },
            { id: 'a14', name: '9-Hole Tournament', time: '8:00 AM', days: 'Sat', instructor: 'Pro Wilson' },
            { id: 'a15', name: 'Beginner Lessons', time: '3:00 PM', days: 'Wed', instructor: 'Pro Wilson' }
        ],
        waitlist: []
    },
    {
        id: 108,
        name: 'Squash Club',
        category: 'Sports',
        instructor: 'Pro Ahmed Hassan',
        bio: 'Professional squash player, PSA certified coach, former world top 50',
        schedule: 'Tue, Fri 5:00 PM - 6:00 PM',
        duration: '60 min',
        location: 'Squash Courts',
        capacity: 8,
        enrolled: 4,
        members: 4,
        level: 'Intermediate+',
        ageGroup: '15+',
        membershipFee: 0,
        image: 'https://images.pexels.com/photos/573929/pexels-photo-573929.jpeg?auto=compress&cs=tinysrgb&w=800',
        icon: 'fa-solid fa-table-tennis-paddle-ball',
        equipment: {
            jersey: { required: true, sizes: ['XS', 'S', 'M', 'L', 'XL'] },
            racket: { required: false },
            shoes: { required: true, sizes: ['36', '37', '38', '39', '40', '41', '42', '43', '44', '45'] },
            goggles: { required: true },
            balls: { required: false }
        },
        activities: [
            { id: 'a23', name: 'Singles Practice', time: '5:00 PM', days: 'Tue/Fri', instructor: 'Pro Ahmed' },
            { id: 'a24', name: 'Doubles Match', time: '9:00 AM', days: 'Sat', instructor: 'Pro Ahmed' },
            { id: 'a25', name: 'Junior Coaching', time: '3:00 PM', days: 'Wed', instructor: 'Pro Ahmed' }
        ],
        waitlist: []
    },
    {
        id: 109,
        name: 'Swimming Club',
        category: 'Aquatics',
        instructor: 'Coach David Okafor',
        bio: 'Former Olympic swimmer, certified lifeguard trainer, multiple gold medalist',
        schedule: 'Mon, Wed, Fri 6:00 AM - 7:00 AM',
        duration: '60 min',
        location: 'Swimming Pool',
        capacity: 15,
        enrolled: 10,
        members: 10,
        level: 'All Levels',
        ageGroup: '8+',
        membershipFee: 0,
        image: 'https://images.pexels.com/photos/261326/pexels-photo-261326.jpeg?auto=compress&cs=tinysrgb&w=800',
        icon: 'fa-solid fa-person-swimming',
        equipment: {
            jersey: { required: true, sizes: ['XS', 'S', 'M', 'L', 'XL'] },
            swimsuit: { required: true, sizes: ['XS', 'S', 'M', 'L', 'XL'] },
            goggles: { required: true },
            swimCap: { required: true, sizes: ['S/M', 'L/XL'] },
            fins: { required: false, sizes: ['S', 'M', 'L'] }
        },
        activities: [
            { id: 'a25', name: 'Lap Swimming', time: '6:00 AM', days: 'Mon/Wed/Fri', instructor: 'Coach David' },
            { id: 'a26', name: 'Technique Clinic', time: '4:00 PM', days: 'Tue/Thu', instructor: 'Coach David' },
            { id: 'a27', name: 'Junior Swim Team', time: '3:00 PM', days: 'Mon/Wed', instructor: 'Coach David' }
        ],
        waitlist: []
    },
    {
        id: 110,
        name: 'Table Tennis Club',
        category: 'Sports',
        instructor: 'Coach Li Wei',
        bio: 'Former Chinese national team member, multiple championship winner',
        schedule: 'Mon, Thu 2:00 PM - 3:00 PM',
        duration: '60 min',
        location: 'Games Room',
        capacity: 8,
        enrolled: 5,
        members: 5,
        level: 'All Levels',
        ageGroup: '10+',
        membershipFee: 0,
        image: 'https://images.pexels.com/photos/61135/pexels-photo-61135.jpeg?auto=compress&cs=tinysrgb&w=800',
        icon: 'fa-solid fa-table-tennis-paddle-ball',
        equipment: {
            jersey: { required: true, sizes: ['XS', 'S', 'M', 'L', 'XL'] },
            paddle: { required: false },
            balls: { required: false },
            shoes: { required: true, sizes: ['36', '37', '38', '39', '40', '41', '42', '43', '44', '45'] }
        },
        activities: [
            { id: 'a27', name: 'Practice Matches', time: '2:00 PM', days: 'Mon/Thu', instructor: 'Coach Li' },
            { id: 'a28', name: 'Tournament', time: '11:00 AM', days: 'Sat', instructor: 'Coach Li' },
            { id: 'a29', name: 'Junior Development', time: '3:00 PM', days: 'Tue', instructor: 'Coach Li' }
        ],
        waitlist: []
    },
    {
        id: 111,
        name: 'Tennis Club',
        category: 'Sports',
        instructor: 'Pro Michael Chang',
        bio: 'Former ATP player, certified tennis professional, Grand Slam quarterfinalist',
        schedule: 'Tue, Thu, Sat 7:00 AM - 8:30 AM',
        duration: '90 min',
        location: 'Tennis Courts',
        capacity: 12,
        enrolled: 8,
        members: 8,
        level: 'All Levels',
        ageGroup: '12+',
        membershipFee: 0,
        image: 'https://images.pexels.com/photos/573929/pexels-photo-573929.jpeg?auto=compress&cs=tinysrgb&w=800',
        icon: 'fa-solid fa-table-tennis-paddle-ball',
        equipment: {
            jersey: { required: true, sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'] },
            racket: { required: false },
            balls: { required: false },
            shoes: { required: true, sizes: ['36', '37', '38', '39', '40', '41', '42', '43', '44', '45'] },
            wristbands: { required: false }
        },
        activities: [
            { id: 'a29', name: 'Singles Practice', time: '7:00 AM', days: 'Tue/Thu/Sat', instructor: 'Pro Michael' },
            { id: 'a30', name: 'Doubles Clinic', time: '4:00 PM', days: 'Wed/Fri', instructor: 'Pro Michael' },
            { id: 'a31', name: 'Junior Academy', time: '3:00 PM', days: 'Mon/Wed', instructor: 'Pro Michael' }
        ],
        waitlist: []
    },
    {
        id: 112,
        name: 'Volleyball Club',
        category: 'Sports',
        instructor: 'Coach Emma Thompson',
        bio: 'Former national team captain, beach volleyball specialist, Olympic bronze medalist',
        schedule: 'Wed, Fri 4:00 PM - 5:30 PM',
        duration: '90 min',
        location: 'Beach Volleyball Court',
        capacity: 12,
        enrolled: 7,
        members: 7,
        level: 'All Levels',
        ageGroup: '14+',
        membershipFee: 0,
        image: 'https://images.pexels.com/photos/1752757/pexels-photo-1752757.jpeg?auto=compress&cs=tinysrgb&w=800',
        icon: 'fa-solid fa-volleyball',
        equipment: {
            jersey: { required: true, sizes: ['XS', 'S', 'M', 'L', 'XL'] },
            shorts: { required: true, sizes: ['XS', 'S', 'M', 'L', 'XL'] },
            kneePads: { required: true, sizes: ['S', 'M', 'L'] },
            volleyball: { required: false },
            ankleBraces: { required: false, sizes: ['S', 'M', 'L'] }
        },
        activities: [
            { id: 'a31', name: 'Beach Volleyball', time: '4:00 PM', days: 'Wed/Fri', instructor: 'Coach Emma' },
            { id: 'a32', name: 'Indoor Practice', time: '3:00 PM', days: 'Tue/Thu', instructor: 'Coach Emma' },
            { id: 'a33', name: 'Weekend Tournament', time: '10:00 AM', days: 'Sat', instructor: 'Coach Emma' }
        ],
        waitlist: []
    },

    // Dance (1)
    {
        id: 113,
        name: 'Ballet and Gymnastics',
        category: 'Dance',
        instructor: 'Madame Elena Petrova',
        bio: 'Former Bolshoi Ballet principal dancer, trained at Vaganova Academy',
        schedule: 'Mon, Wed 3:00 PM - 4:00 PM',
        duration: '60 min',
        location: 'Dance Studio A',
        capacity: 15,
        enrolled: 10,
        members: 10,
        level: 'Kids',
        ageGroup: '5-12',
        membershipFee: 0,
        image: 'https://images.pexels.com/photos/974579/pexels-photo-974579.jpeg?auto=compress&cs=tinysrgb&w=800',
        icon: 'fa-solid fa-shoe-prints',
        equipment: {
            jersey: { required: true, sizes: ['XS', 'S', 'M', 'L'] },
            leotard: { required: true, sizes: ['XS', 'S', 'M', 'L'] },
            balletShoes: { required: true, sizes: ['32', '33', '34', '35', '36', '37', '38'] },
            tights: { required: true, sizes: ['XS', 'S', 'M', 'L'] }
        },
        activities: [
            { id: 'a5', name: 'Beginner Ballet', time: '3:00 PM', days: 'Mon/Wed', instructor: 'Madame Elena' },
            { id: 'a6', name: 'Gymnastics', time: '4:30 PM', days: 'Tue/Thu', instructor: 'Coach Anna' },
            { id: 'a7', name: 'Annual Recital', time: '2:00 PM', days: 'Sat', instructor: 'Madame Elena' }
        ],
        waitlist: []
    },

    // Martial Arts (1)
    {
        id: 114,
        name: 'Karate Section',
        category: 'Martial Arts',
        instructor: 'Sensei Kenji Tanaka',
        bio: '5th Dan Black Belt, former national champion, 30 years teaching experience',
        schedule: 'Mon, Thu 5:30 PM - 6:30 PM',
        duration: '60 min',
        location: 'Dojo',
        capacity: 15,
        enrolled: 9,
        members: 9,
        level: 'Beginner+',
        ageGroup: '7+',
        membershipFee: 0,
        image: 'https://images.pexels.com/photos/260447/pexels-photo-260447.jpeg?auto=compress&cs=tinysrgb&w=800',
        icon: 'fa-solid fa-hand-fist',
        equipment: {
            jersey: { required: true, sizes: ['XS', 'S', 'M', 'L', 'XL'] },
            gi: { required: true, sizes: ['000', '00', '0', '1', '2', '3', '4', '5'] },
            belt: { required: true, sizes: ['000', '00', '0', '1', '2', '3', '4', '5'] },
            gloves: { required: false, sizes: ['S', 'M', 'L'] }
        },
        activities: [
            { id: 'a15', name: 'Kata Practice', time: '5:30 PM', days: 'Mon/Thu', instructor: 'Sensei Tanaka' },
            { id: 'a16', name: 'Sparring Session', time: '10:00 AM', days: 'Sat', instructor: 'Sensei Tanaka' },
            { id: 'a17', name: 'Belt Testing', time: '2:00 PM', days: 'Sun', instructor: 'Sensei Tanaka' }
        ],
        waitlist: []
    },

    // Mind Sports (2)
    {
        id: 115,
        name: 'Chess Club',
        category: 'Mind Sports',
        instructor: 'Grandmaster Ade Okafor',
        bio: 'International Master, 20 years coaching experience, Nigerian champion',
        schedule: 'Wed 3:00 PM - 5:00 PM',
        duration: '120 min',
        location: 'Clubhouse - Room 201',
        capacity: 16,
        enrolled: 10,
        members: 10,
        level: 'All Ages',
        ageGroup: 'All Ages',
        membershipFee: 0,
        image: 'https://images.pexels.com/photos/3768916/pexels-photo-3768916.jpeg?auto=compress&cs=tinysrgb&w=800',
        icon: 'fa-solid fa-chess',
        equipment: {
            jersey: { required: false, sizes: ['XS', 'S', 'M', 'L', 'XL'] },
            chessSet: { required: false },
            clock: { required: false }
        },
        activities: [
            { id: 'a9', name: 'Tournament', time: '3:00 PM', days: 'Wed', instructor: 'GM Ade' },
            { id: 'a10', name: 'Strategy Workshop', time: '2:00 PM', days: 'Sat', instructor: 'GM Ade' },
            { id: 'a11', name: 'Junior Chess', time: '4:00 PM', days: 'Tue', instructor: 'GM Ade' }
        ],
        waitlist: []
    },
    {
        id: 116,
        name: 'Scrabble Club',
        category: 'Mind Sports',
        instructor: 'Dr. Chinedu Okeke',
        bio: 'PhD in Linguistics, national Scrabble champion, 3x African champion',
        schedule: 'Fri 4:00 PM - 5:30 PM',
        duration: '90 min',
        location: 'Library',
        capacity: 12,
        enrolled: 7,
        members: 7,
        level: 'All Ages',
        ageGroup: '10+',
        membershipFee: 0,
        image: 'https://images.pexels.com/photos/3768916/pexels-photo-3768916.jpeg?auto=compress&cs=tinysrgb&w=800',
        icon: 'fa-solid fa-font',
        equipment: {
            jersey: { required: false, sizes: ['XS', 'S', 'M', 'L', 'XL'] },
            scrabbleSet: { required: false },
            dictionary: { required: false }
        },
        activities: [
            { id: 'a21', name: 'Tournament', time: '4:00 PM', days: 'Fri', instructor: 'Dr. Okeke' },
            { id: 'a22', name: 'Practice Games', time: '2:00 PM', days: 'Sat', instructor: 'Dr. Okeke' },
            { id: 'a23', name: 'Word Study', time: '3:00 PM', days: 'Wed', instructor: 'Dr. Okeke' }
        ],
        waitlist: []
    },

    // Games (1)
    {
        id: 117,
        name: 'Pool/Snooker Club',
        category: 'Games',
        instructor: 'Master Chen Wei',
        bio: 'Professional snooker player, 3x national champion, 147 break achiever',
        schedule: 'Tue, Thu 3:00 PM - 4:30 PM',
        duration: '90 min',
        location: 'Games Room',
        capacity: 8,
        enrolled: 4,
        members: 4,
        level: 'All Levels',
        ageGroup: '16+',
        membershipFee: 0,
        image: 'https://images.pexels.com/photos/1937092/pexels-photo-1937092.jpeg?auto=compress&cs=tinysrgb&w=800',
        icon: 'fa-solid fa-table',
        equipment: {
            jersey: { required: false, sizes: ['S', 'M', 'L', 'XL'] },
            cue: { required: false },
            chalk: { required: false },
            gloves: { required: false }
        },
        activities: [
            { id: 'a17', name: '8-Ball Tournament', time: '3:00 PM', days: 'Tue/Thu', instructor: 'Master Chen' },
            { id: 'a18', name: 'Snooker Practice', time: '2:00 PM', days: 'Sat', instructor: 'Master Chen' },
            { id: 'a19', name: 'Beginner Lessons', time: '4:00 PM', days: 'Mon', instructor: 'Master Chen' }
        ],
        waitlist: []
    },

    // Social (1)
    {
        id: 118,
        name: 'RA Ladies Association',
        category: 'Social',
        instructor: 'Mrs. Grace Adebayo',
        bio: 'Community leader, women empowerment advocate, philanthropist',
        schedule: 'Wed 10:00 AM - 12:00 PM',
        duration: '120 min',
        location: 'Clubhouse - Lounge',
        capacity: 30,
        enrolled: 22,
        members: 22,
        level: 'Women Only',
        ageGroup: '18+',
        membershipFee: 0,
        image: 'https://images.pexels.com/photos/3768916/pexels-photo-3768916.jpeg?auto=compress&cs=tinysrgb&w=800',
        icon: 'fa-solid fa-people-group',
        equipment: {
            jersey: { required: false, sizes: ['XS', 'S', 'M', 'L', 'XL'] }
        },
        activities: [
            { id: 'a19', name: 'Monthly Meeting', time: '10:00 AM', days: 'Wed', instructor: 'Mrs. Adebayo' },
            { id: 'a20', name: 'Social Gathering', time: '3:00 PM', days: 'Fri', instructor: 'Mrs. Adebayo' },
            { id: 'a21', name: 'Charity Event', time: '11:00 AM', days: 'Sat', instructor: 'Mrs. Adebayo' }
        ],
        waitlist: []
    }
];

// Equipment Catalog (Full - for events and facilities)
export const equipmentCatalog = [
    // Sporting Equipment
    { id: 's1', category: 'Sporting Equipment', name: 'Basketball', icon: 'fa-solid fa-basketball', available: 15, sportingOnly: true, sizes: [] },
    { id: 's2', category: 'Sporting Equipment', name: 'Football', icon: 'fa-solid fa-futbol', available: 20, sportingOnly: true, sizes: [] },
    { id: 's3', category: 'Sporting Equipment', name: 'Tennis Racket', icon: 'fa-solid fa-table-tennis-paddle-ball', available: 12, sportingOnly: true, sizes: [] },
    { id: 's4', category: 'Sporting Equipment', name: 'Tennis Balls', icon: 'fa-solid fa-circle', available: 30, sportingOnly: true, sizes: [] },
    { id: 's5', category: 'Sporting Equipment', name: 'Badminton Racket', icon: 'fa-solid fa-table-tennis-paddle-ball', available: 10, sportingOnly: true, sizes: [] },
    { id: 's6', category: 'Sporting Equipment', name: 'Badminton Shuttlecocks', icon: 'fa-solid fa-feather', available: 25, sportingOnly: true, sizes: [] },
    { id: 's7', category: 'Sporting Equipment', name: 'Squash Racket', icon: 'fa-solid fa-table-tennis-paddle-ball', available: 8, sportingOnly: true, sizes: [] },
    { id: 's8', category: 'Sporting Equipment', name: 'Squash Ball', icon: 'fa-solid fa-circle', available: 20, sportingOnly: true, sizes: [] },
    { id: 's9', category: 'Sporting Equipment', name: 'Table Tennis Paddle', icon: 'fa-solid fa-table-tennis-paddle-ball', available: 15, sportingOnly: true, sizes: [] },
    { id: 's10', category: 'Sporting Equipment', name: 'Table Tennis Balls', icon: 'fa-solid fa-circle', available: 40, sportingOnly: true, sizes: [] },
    { id: 's11', category: 'Sporting Equipment', name: 'Yoga Mat', icon: 'fa-solid fa-mat', available: 20, sportingOnly: true, sizes: [] },
    { id: 's12', category: 'Sporting Equipment', name: 'Swimming Goggles', icon: 'fa-solid fa-glasses', available: 25, sportingOnly: true, sizes: [] },
    { id: 's13', category: 'Sporting Equipment', name: 'Swim Cap', icon: 'fa-solid fa-hat-cowboy', available: 30, sportingOnly: true, sizes: [] },
    { id: 's14', category: 'Sporting Equipment', name: 'Kickboard', icon: 'fa-solid fa-water', available: 15, sportingOnly: true, sizes: [] },
    { id: 's15', category: 'Sporting Equipment', name: 'Volleyball', icon: 'fa-solid fa-volleyball', available: 10, sportingOnly: true, sizes: [] },
    { id: 's16', category: 'Sporting Equipment', name: 'Golf Clubs', icon: 'fa-solid fa-golf-ball-tee', available: 5, sportingOnly: true, sizes: [] },
    { id: 's17', category: 'Sporting Equipment', name: 'Golf Balls', icon: 'fa-solid fa-circle', available: 50, sportingOnly: true, sizes: [] },
    // Cycling Equipment
    { id: 's18', category: 'Sporting Equipment', name: 'Cycling Helmet', icon: 'fa-solid fa-helmet-safety', available: 10, sportingOnly: true, sizes: ['S', 'M', 'L'] },
    { id: 's19', category: 'Sporting Equipment', name: 'Cycling Gloves', icon: 'fa-solid fa-hand-peace', available: 15, sportingOnly: true, sizes: ['S', 'M', 'L'] },
    { id: 's20', category: 'Sporting Equipment', name: 'Water Bottle', icon: 'fa-solid fa-bottle-water', available: 30, sportingOnly: true, sizes: [] },
    { id: 's21', category: 'Sporting Equipment', name: 'Cycling Shorts', icon: 'fa-solid fa-pants', available: 12, sportingOnly: true, sizes: ['XS', 'S', 'M', 'L', 'XL'] },
    { id: 's22', category: 'Sporting Equipment', name: 'Jersey', icon: 'fa-solid fa-shirt', available: 50, sportingOnly: true, sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'] },
    // Football Equipment
    { id: 's23', category: 'Sporting Equipment', name: 'Football Boots', icon: 'fa-solid fa-shoe-prints', available: 20, sportingOnly: true, sizes: ['36', '37', '38', '39', '40', '41', '42', '43', '44', '45'] },
    { id: 's24', category: 'Sporting Equipment', name: 'Shin Guards', icon: 'fa-solid fa-shield', available: 25, sportingOnly: true, sizes: ['S', 'M', 'L'] },
    // Basketball Equipment
    { id: 's25', category: 'Sporting Equipment', name: 'Basketball Shoes', icon: 'fa-solid fa-shoe-prints', available: 15, sportingOnly: true, sizes: ['36', '37', '38', '39', '40', '41', '42', '43', '44', '45'] },
    // Tennis/Squash/Badminton Equipment
    { id: 's26', category: 'Sporting Equipment', name: 'Tennis Shoes', icon: 'fa-solid fa-shoe-prints', available: 15, sportingOnly: true, sizes: ['36', '37', '38', '39', '40', '41', '42', '43', '44', '45'] },
    { id: 's27', category: 'Sporting Equipment', name: 'Running Shoes', icon: 'fa-solid fa-shoe-prints', available: 20, sportingOnly: true, sizes: ['36', '37', '38', '39', '40', '41', '42', '43', '44', '45'] },
    // Swimming Equipment
    { id: 's28', category: 'Sporting Equipment', name: 'Swimsuit', icon: 'fa-solid fa-swimmer', available: 20, sportingOnly: true, sizes: ['XS', 'S', 'M', 'L', 'XL'] },
    // Karate Equipment
    { id: 's29', category: 'Sporting Equipment', name: 'Gi (Uniform)', icon: 'fa-solid fa-tshirt', available: 15, sportingOnly: true, sizes: ['000', '00', '0', '1', '2', '3', '4', '5'] },
    { id: 's30', category: 'Sporting Equipment', name: 'Karate Belt', icon: 'fa-solid fa-grip-lines', available: 20, sportingOnly: true, sizes: ['000', '00', '0', '1', '2', '3', '4', '5'] },
    // Ballet Equipment
    { id: 's31', category: 'Sporting Equipment', name: 'Ballet Shoes', icon: 'fa-solid fa-shoe-prints', available: 15, sportingOnly: true, sizes: ['32', '33', '34', '35', '36', '37', '38'] },
    { id: 's32', category: 'Sporting Equipment', name: 'Leotard', icon: 'fa-solid fa-shirt', available: 20, sportingOnly: true, sizes: ['XS', 'S', 'M', 'L'] },
    { id: 's33', category: 'Sporting Equipment', name: 'Tights', icon: 'fa-solid fa-socks', available: 25, sportingOnly: true, sizes: ['XS', 'S', 'M', 'L'] },

    // Event Equipment (keep all your existing event equipment)
    { id: 'e1', category: 'Seating', name: 'Folding Chairs', icon: 'fa-solid fa-chair', available: 200, sportingOnly: false, sizes: [] },
    { id: 'e2', category: 'Seating', name: 'Banquet Chairs', icon: 'fa-solid fa-couch', available: 150, sportingOnly: false, sizes: [] },
    { id: 'e3', category: 'Seating', name: 'Throne Chairs (VIP)', icon: 'fa-solid fa-crown', available: 10, sportingOnly: false, sizes: [] },
    { id: 'e4', category: 'Seating', name: 'Stools', icon: 'fa-solid fa-stool', available: 50, sportingOnly: false, sizes: [] },
    { id: 'e5', category: 'Seating', name: 'Benches', icon: 'fa-solid fa-chair', available: 30, sportingOnly: false, sizes: [] },
    { id: 'e6', category: 'Tables', name: 'Round Tables (6-seater)', icon: 'fa-solid fa-circle', available: 40, sportingOnly: false, sizes: [] },
    { id: 'e7', category: 'Tables', name: 'Rectangular Tables (8-seater)', icon: 'fa-solid fa-table', available: 35, sportingOnly: false, sizes: [] },
    { id: 'e8', category: 'Tables', name: 'High Top Tables', icon: 'fa-solid fa-table', available: 20, sportingOnly: false, sizes: [] },
    { id: 'e9', category: 'Tables', name: 'Cocktail Tables', icon: 'fa-solid fa-martini-glass', available: 25, sportingOnly: false, sizes: [] },
    { id: 'e10', category: 'Tables', name: 'Kids Tables', icon: 'fa-solid fa-child', available: 15, sportingOnly: false, sizes: [] },
    { id: 'e11', category: 'Linens', name: 'White Tablecloths (6ft)', icon: 'fa-solid fa-sheet-plastic', available: 100, sportingOnly: false, sizes: [] },
    { id: 'e12', category: 'Linens', name: 'Gold Tablecloths', icon: 'fa-solid fa-sheet-plastic', available: 50, sportingOnly: false, sizes: [] },
    { id: 'e13', category: 'Linens', name: 'Chair Covers (White)', icon: 'fa-solid fa-chair', available: 200, sportingOnly: false, sizes: [] },
    { id: 'e14', category: 'Linens', name: 'Chair Sashes (Gold)', icon: 'fa-solid fa-ribbon', available: 150, sportingOnly: false, sizes: [] },
    { id: 'e15', category: 'Linens', name: 'Table Runners', icon: 'fa-solid fa-ruler', available: 80, sportingOnly: false, sizes: [] },
    { id: 'e16', category: 'Linens', name: 'Napkins (Cloth)', icon: 'fa-solid fa-napkin', available: 300, sportingOnly: false, sizes: [] },
    { id: 'e17', category: 'Audio', name: 'Wireless Microphones', icon: 'fa-solid fa-microphone', available: 15, sportingOnly: false, sizes: [] },
    { id: 'e18', category: 'Audio', name: 'Handheld Microphones', icon: 'fa-solid fa-microphone', available: 20, sportingOnly: false, sizes: [] },
    { id: 'e19', category: 'Audio', name: 'Lavalier Mic (Lapel)', icon: 'fa-solid fa-microphone-lines', available: 10, sportingOnly: false, sizes: [] },
    { id: 'e20', category: 'Audio', name: 'Speaker Systems (Pair)', icon: 'fa-solid fa-volume-high', available: 8, sportingOnly: false, sizes: [] },
    { id: 'e21', category: 'Audio', name: 'Subwoofers', icon: 'fa-solid fa-volume-low', available: 4, sportingOnly: false, sizes: [] },
    { id: 'e22', category: 'Audio', name: 'PA System', icon: 'fa-solid fa-tower-broadcast', available: 3, sportingOnly: false, sizes: [] },
    { id: 'e23', category: 'Audio', name: 'Audio Mixer', icon: 'fa-solid fa-sliders', available: 2, sportingOnly: false, sizes: [] },
    { id: 'e24', category: 'Audio', name: 'Speaker Stands', icon: 'fa-solid fa-arrow-up-wide-short', available: 16, sportingOnly: false, sizes: [] },
    { id: 'e25', category: 'Visual', name: 'Projector', icon: 'fa-solid fa-video', available: 5, sportingOnly: false, sizes: [] },
    { id: 'e26', category: 'Visual', name: 'Projection Screen', icon: 'fa-solid fa-tv', available: 5, sportingOnly: false, sizes: [] },
    { id: 'e27', category: 'Visual', name: 'LED TV (55")', icon: 'fa-solid fa-tv', available: 6, sportingOnly: false, sizes: [] },
    { id: 'e28', category: 'Visual', name: 'LED TV (65")', icon: 'fa-solid fa-tv', available: 4, sportingOnly: false, sizes: [] },
    { id: 'e29', category: 'Visual', name: 'TV Stand/Trolley', icon: 'fa-solid fa-cart-flatbed', available: 8, sportingOnly: false, sizes: [] },
    { id: 'e30', category: 'Visual', name: 'Whiteboard/Flip Chart', icon: 'fa-solid fa-chalkboard', available: 10, sportingOnly: false, sizes: [] },
    { id: 'e31', category: 'Stage', name: 'Stage Platforms (4x8ft)', icon: 'fa-solid fa-cubes', available: 20, sportingOnly: false, sizes: [] },
    { id: 'e32', category: 'Stage', name: 'Stage Skirting', icon: 'fa-solid fa-rug', available: 15, sportingOnly: false, sizes: [] },
    { id: 'e33', category: 'Stage', name: 'Carpet (Rolls)', icon: 'fa-solid fa-rug', available: 10, sportingOnly: false, sizes: [] },
    { id: 'e34', category: 'Stage', name: 'Red Carpet', icon: 'fa-solid fa-road', available: 5, sportingOnly: false, sizes: [] },
    { id: 'e35', category: 'Stage', name: 'Dance Floor (Interlocking)', icon: 'fa-solid fa-shoe-prints', available: 50, sportingOnly: false, sizes: [] },
    { id: 'e36', category: 'Lighting', name: 'Stage Lights (Par Cans)', icon: 'fa-solid fa-lightbulb', available: 20, sportingOnly: false, sizes: [] },
    { id: 'e37', category: 'Lighting', name: 'Spotlights', icon: 'fa-solid fa-lightbulb', available: 4, sportingOnly: false, sizes: [] },
    { id: 'e38', category: 'Lighting', name: 'LED Uplights', icon: 'fa-solid fa-lightbulb', available: 12, sportingOnly: false, sizes: [] },
    { id: 'e39', category: 'Lighting', name: 'Disco Ball', icon: 'fa-solid fa-disco-ball', available: 2, sportingOnly: false, sizes: [] },
    { id: 'e40', category: 'Lighting', name: 'String Lights', icon: 'fa-solid fa-star', available: 10, sportingOnly: false, sizes: [] },
    { id: 'e41', category: 'Decor', name: 'Centerpieces (Vases)', icon: 'fa-solid fa-vase', available: 30, sportingOnly: false, sizes: [] },
    { id: 'e42', category: 'Decor', name: 'Candlestick Holders', icon: 'fa-solid fa-candle-holder', available: 40, sportingOnly: false, sizes: [] },
    { id: 'e43', category: 'Decor', name: 'Flower Stands', icon: 'fa-solid fa-flower', available: 20, sportingOnly: false, sizes: [] },
    { id: 'e44', category: 'Decor', name: 'Backdrop Stand', icon: 'fa-solid fa-frame', available: 5, sportingOnly: false, sizes: [] },
    { id: 'e45', category: 'Decor', name: 'Backdrop Curtain', icon: 'fa-solid fa-curtains', available: 8, sportingOnly: false, sizes: [] },
    { id: 'e46', category: 'Serving', name: 'Buffet Stations', icon: 'fa-solid fa-utensils', available: 10, sportingOnly: false, sizes: [] },
    { id: 'e47', category: 'Serving', name: 'Chafing Dishes', icon: 'fa-solid fa-oven', available: 30, sportingOnly: false, sizes: [] },
    { id: 'e48', category: 'Serving', name: 'Water Dispensers', icon: 'fa-solid fa-faucet', available: 15, sportingOnly: false, sizes: [] },
    { id: 'e49', category: 'Serving', name: 'Coffee Urns', icon: 'fa-solid fa-mug-hot', available: 8, sportingOnly: false, sizes: [] },
    { id: 'e50', category: 'Serving', name: 'Dinner Plates', icon: 'fa-solid fa-plate-wheat', available: 300, sportingOnly: false, sizes: [] },
    { id: 'e51', category: 'Serving', name: 'Glassware (Sets)', icon: 'fa-solid fa-wine-glass', available: 200, sportingOnly: false, sizes: [] },
    { id: 'e52', category: 'Serving', name: 'Cutlery Sets', icon: 'fa-solid fa-utensils', available: 300, sportingOnly: false, sizes: [] }
];

// Section Equipment (for section join modal)
export const sectionEquipment = equipmentCatalog.filter(item => item.sportingOnly === true);

// Group equipment by category helper
export const getEquipmentByCategory = () => {
    return equipmentCatalog.reduce((acc, item) => {
        if (!acc[item.category]) {
            acc[item.category] = [];
        }
        acc[item.category].push(item);
        return acc;
    }, {});
};

// Time slots for bookings
export const timeSlots = [
    '8:00 AM', '9:00 AM', '10:00 AM', '11:00 AM', '12:00 PM',
    '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM',
    '6:00 PM', '7:00 PM', '8:00 PM', '9:00 PM', '10:00 PM'
];

// Event types
export const eventTypes = [
    { id: 'private', name: 'Private Function', requiresClearance: false },
    { id: 'corporate', name: 'Corporate/Company', requiresClearance: false },
    { id: 'club', name: 'Club Section', requiresClearance: false },
    { id: 'religious', name: 'Religious Event', requiresClearance: true },
    { id: 'political', name: 'Political Event', requiresClearance: true },
    { id: 'social', name: 'Social Gathering', requiresClearance: false },
    { id: 'sporting', name: 'Sporting Activity', requiresClearance: false }
];

// Booking statuses
export const bookingStatuses = [
    { id: 'pending', name: 'Pending', color: '#ffc107', icon: 'fa-solid fa-clock' },
    { id: 'approved', name: 'Approved', color: '#28a745', icon: 'fa-solid fa-check-circle' },
    { id: 'rejected', name: 'Rejected', color: '#dc3545', icon: 'fa-solid fa-times-circle' },
    { id: 'cancelled', name: 'Cancelled', color: '#6c757d', icon: 'fa-solid fa-ban' },
    { id: 'waitlist', name: 'Waitlist', color: '#17a2b8', icon: 'fa-solid fa-hourglass-half' },
    { id: 'location_changed', name: 'Location Changed', color: '#007bff', icon: 'fa-solid fa-location-dot' }
];

// Notification types
export const notificationTypes = {
    success: { icon: 'fa-solid fa-check-circle', color: '#28a745' },
    warning: { icon: 'fa-solid fa-exclamation-triangle', color: '#ffc107' },
    info: { icon: 'fa-solid fa-info-circle', color: '#007bff' },
    error: { icon: 'fa-solid fa-times-circle', color: '#dc3545' }
};

// Default user (for testing)
export const defaultUser = {
    id: 1,
    first_name: 'John',
    last_name: 'Doe',
    email: 'john@nlngra.com',
    phone: '+2348012345678',
    whatsApp: '+2348012345678',
    address: 'Bonny RA',
    profilePicture: null
};